import { Row, Col, Button, Loader } from "rsuite";
import { Container } from "react-bootstrap";
import { ChevronRight, CheckCircleFill, CarFront } from "react-bootstrap-icons";
import { useOrderCreation, PassengerType } from "../context/OrderCreationContext";
import { PassengerCounter } from "../components/PassengerCounter";
import { authUserData } from "../../../../../service";
import type { Vehicle } from "../../../../../my-type";
import { checkIsVehicleCanFit, getVehicleFeeWithAddress } from "../../../../../utilities/VehicleHelper";
import { getServiceFeeDataForTeam } from "../../../../../service/VehicleService";
import { useEffect, useState, useCallback } from "react";

export const RideRequirements: React.FC = () => {
  const {
    adultCount,
    babyCount,
    changePassengerCount,
    displayRegistedLuggage,
    isShowWarning,
    userRegistLuggages,
    setStep,
    userVehicle,
    setUserVehicle,
    vehicleTypes,
    setVehicleServiceBasicFee,
    selectedPlace,
    selectedTerminal,
    setIsShowWarning,
    serviceFeeData,
    setServiceFeeData
  } = useOrderCreation();

  const authUser = authUserData();
  const [isLoadingServiceFee, setIsLoadingServiceFee] = useState<boolean>(false);

  // Fetch service fee data from API on mount
  const fetchServiceFeeData = useCallback(async () => {
    if (authUser?.team?.id && serviceFeeData.length === 0) {
      setIsLoadingServiceFee(true);
      try {
        const data = await getServiceFeeDataForTeam(authUser.team.id);
        if (data) {
          setServiceFeeData(data);
        }
      } catch (error) {
        console.error("Error fetching service fee data:", error);
      } finally {
        setIsLoadingServiceFee(false);
      }
    }
  }, [authUser?.team?.id, serviceFeeData.length, setServiceFeeData]);

  useEffect(() => {
    fetchServiceFeeData();
  }, [fetchServiceFeeData]);

  const checkVehicleCanFit = (varVehicle: Vehicle) => {
    const isCanFit = checkIsVehicleCanFit(varVehicle, adultCount + babyCount, userRegistLuggages);
    if (!isCanFit) {
      if (userVehicle && userVehicle.id === varVehicle.id) {
        setUserVehicle(undefined);
      }
    }
    return isCanFit;
  };

  const handleVehicleSelect = (element: Vehicle) => {
    if (checkIsVehicleCanFit(element, adultCount + babyCount, userRegistLuggages)) {
      let tempServiceBasicFee = getVehicleFeeWithAddress(
        serviceFeeData,
        element,
        selectedPlace!,
        selectedTerminal!.code.substring(0, 3)
      );

      if (tempServiceBasicFee) {
        setUserVehicle(element);
        setVehicleServiceBasicFee(tempServiceBasicFee);
      } else {
        alert('車輛基本車資定義不存在');
      }
    } else {
      alert('車輛不符合您的需求');
    }
  };

  const handleNext = () => {
    if (userVehicle && adultCount > 0 && userRegistLuggages.filter((element) => element.quantity > 0).length > 0) {
      setIsShowWarning(false);
      setStep(4);
    } else {
      setIsShowWarning(true);
    }
  };

  return (
    <Container fluid="md" style={{ backgroundColor: 'white' }} className="rounded">
      <br />
      <Row>
        <Col style={{ textAlign: 'left' }}><h5>旅客人數</h5></Col>
      </Row>
      <br />

      <PassengerCounter
        label="一般"
        count={adultCount}
        onIncrement={() => changePassengerCount(PassengerType.Adult, 1)}
        onDecrement={() => changePassengerCount(PassengerType.Adult, -1)}
      />
      <br />

      <PassengerCounter
        label="4歲以下兒童"
        count={babyCount}
        onIncrement={() => changePassengerCount(PassengerType.Baby, 1)}
        onDecrement={() => changePassengerCount(PassengerType.Baby, -1)}
      />
      <br />

      <Row>
        <Col style={{ textAlign: 'left' }} xs={15}>
          行李數&nbsp;
          {(isShowWarning && (userRegistLuggages.filter((element) => element.quantity > 0).length === 0)) &&
            <span style={{ color: 'red', fontSize: '11px' }}>未填寫</span>
          }
        </Col>
        <Col xs={7} style={{ textAlign: 'right' }}>{displayRegistedLuggage(true)}</Col>
        <Col xs={2}> <ChevronRight onClick={() => setStep(3)} /></Col>
      </Row>
      <br />
      <br />

      <Row>
        <Col style={{ textAlign: 'left' }}>
          <h5>選擇車種&nbsp;
            {(isShowWarning && !userVehicle) &&
              <span style={{ color: 'red', fontSize: '11px' }}>未填寫</span>
            }
            {isLoadingServiceFee && <Loader size="xs" />}
          </h5>
        </Col>
      </Row>
      <br />

      {authUser && vehicleTypes.map((element, index) => {
        let serviceFeeByVehicle = getVehicleFeeWithAddress(
          serviceFeeData,
          element,
          selectedPlace!,
          selectedTerminal!.code.substring(0, 3)
        );

        return (
          <div key={index}>
            <Row
              style={checkVehicleCanFit(element) ? {} : { color: 'lightgray' }}
              onClick={() => handleVehicleSelect(element)}
            >
              <Col xs={2}><CarFront /></Col>
              <Col style={{ textAlign: 'left' }} xs={15}>{element.vehiclename}</Col>
              <Col style={{ textAlign: 'right' }} xs={4}>
                ${serviceFeeByVehicle ? serviceFeeByVehicle.price : 0}
              </Col>
              <Col xs={3}>
                {userVehicle && userVehicle.id === element.id &&
                  <CheckCircleFill style={{ fontSize: '20px' }} />
                }
              </Col>
            </Row>
            <br />
          </div>
        );
      })}

      <br />
      <Row>
        <Col xs={24} md={24} style={{ textAlign: 'right', marginBottom: '15px' }}>
          <Button appearance="primary" color="yellow" onClick={handleNext}>
            下一步
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
